import * as React from 'react';

import { LiffContext } from 'contexts/LiffContext';

type UseLiff = {
  accessToken: string | null;
  initialized: boolean;
  isInClient: boolean;
  loggedIn: boolean;
  userId: string | null;
  closeWindow?: () => void;
  login?: () => void;
  logout?: () => void;
};

export const useLiff = (): UseLiff => {
  const liff = React.useContext(LiffContext);
  if (typeof window === 'undefined' || !liff) {
    return {
      accessToken: null,
      initialized: false,
      isInClient: false,
      loggedIn: false,
      userId: null,
    };
  }

  const sub = liff.getDecodedIDToken()?.sub ?? null;

  return {
    accessToken: liff.getAccessToken(),
    initialized: true,
    isInClient: liff.isInClient(),
    loggedIn: liff.isLoggedIn(),
    userId: sub,
    closeWindow: liff.closeWindow,
    login: liff.login,
    logout: liff.logout,
  };
};
